import { faXmarkCircle } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

export default function Chip({
  label,
  onClick,
  isClearable,
  onClear,
  dataTestId,
}) {
  const handleClear = (e) => {
    e.stopPropagation(); // Prevent the click from bubbling up to the parent div
    onClear(e);
  };

  return (
    <div
      className={`
        ${
          isClearable
            ? "border-indigo-500 dark:border-white/10 bg-indigo-100 dark:bg-indigo-500/50"
            : "border-black/10 dark:border-white/10 hover:border-indigo-500 dark:bg-white/20"
        } hover:bg-indigo-100 dark:text-white  dark:hover:bg-indigo-500/50 text-gray-700 rounded-full py-1 px-2 flex flex-wrap border  hover:text-indigo-600 transition-colors cursor-pointer truncate`}
      onClick={onClick}
      data-testid={dataTestId}
    >
      {label}
      {isClearable && (
        <button
          onClick={handleClear}
          className="hover:text-indigo-800 transition-colors ml-1"
          aria-label="Clear chip"
        >
          <FontAwesomeIcon icon={faXmarkCircle} />
        </button>
      )}
    </div>
  );
}
